export const splitTagsString = (string: string) =>
  string
    .split(',')
    .map((el) => el.trim())
    .filter((el) => el);
